<!-- No image state - just show Add button -->
@if (!hasImage()) {
  @if (!isReadOnly) {
    <cs-button tertiary icon="camera" [label]="LL.editFood.buttons.addImage()"
    (click)="addImage()"></cs-button>
  }
} @else {
  <div class="image-container">
    <div class="image-holder">
      <img class="image-uploader-img" [srcset]="imageService.getSrcSetByDpi(image)" (error)="handleImageLoadError($event)" />
    </div>
    @if (!isReadOnly && offerRemoveOption) {
      <div class="image-actions">
        <cs-button tertiary class="remove-button" [label]="LL.common.buttons.remove()"
        (click)="handleRemoveImage()"></cs-button>
      </div>
    }
  </div>
}

<!-- Has image state - show image with Remove button -->
